export function inr(value) {
  const n = Number(value);
  if (value == null || value === "" || Number.isNaN(n)) return "—";
  if (Math.abs(n) >= 10000000) return "₹" + (n / 10000000).toFixed(2) + " Cr";
  if (Math.abs(n) >= 100000) return "₹" + (n / 100000).toFixed(2) + " L";
  return "₹" + n.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function inrFull(value) {
  const n = Number(value);
  if (value == null || value === "" || Number.isNaN(n)) return "—";
  return "₹" + n.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function formatDate(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function fromNow(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  const s = (Date.now() - d.getTime()) / 1000;
  if (Math.abs(s) < 60) return "just now";
  const m = s / 60;
  if (Math.abs(m) < 60) return `${Math.round(m)}m ago`;
  const h = m / 60;
  if (Math.abs(h) < 24) return `${Math.round(h)}h ago`;
  const days = h / 24;
  if (Math.abs(days) < 30) return `${Math.round(days)}d ago`;
  return formatDate(v);
}

export function titleize(key) {
  return String(key)
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}

const MONEY_KEYS = ["amount", "salary", "income", "emi", "obligation", "disbursed"];
const DATE_KEYS = ["_at", "_date", "date_of", "created", "updated"];

export function displayValue(key, v) {
  const lk = String(key).toLowerCase();
  if (v == null || v === "") return "—";
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (Array.isArray(v)) return v.length ? v.map((x) => (typeof x === "object" ? JSON.stringify(x) : String(x))).join(", ") : "—";
  if (typeof v === "object") return JSON.stringify(v);
  if (MONEY_KEYS.some((k) => lk.includes(k)) && !Number.isNaN(Number(v))) return inrFull(v);
  if (DATE_KEYS.some((k) => lk.includes(k)) && /\d{4}-\d{2}-\d{2}T/.test(String(v))) return formatDateTime(v);
  return String(v);
}

export const inrCompact = inr;
